import { useContext } from 'react';

import { TimeseriesXFormatterContext } from '../context/TimeseriesXFormatter.context.js';

export const useTimeseriesXFormatter = () => {
  const context = useContext(TimeseriesXFormatterContext);

  if (context === undefined) {
    throw new Error(
      'useTimeseriesXFormatter must be used within a TimeseriesXFormatterContext provider',
    );
  }
  return context;
};
